import styled from 'styled-components'
import theme from '../../../../styles/theme'

export const IconWrapper = styled.svg`
  fill: ${props => props.fill || theme.bodyFontColor};
  width: 1em;
  height: 1em;
  display: block;
  font-size: 24px;
  user-select: none;
  flex-shrink: 0;
`
